import clsx from "clsx";
import type { ReactNode } from "react";

type FontSizeType = "normal" | "small";

/**
 * シンプルな説明の一覧を表示するコンポーネント
 *
 * @param instructions 説明文の配列
 * @param className クラス
 */
export function InstructionList({
  instructions,
  className,
  fontSize,
  mark = "■",
  lineSpacing = "normal",
}: {
  instructions: ReactNode[];
  className?: string;
  fontSize?: FontSizeType;
  mark?: string;
  lineSpacing?: "none" | "normal" | "narrow";
}) {
  const classOfMark = `before:content-['${mark}']`;
  return (
    <div
      className={clsx(
        fontSize === "normal" && "text-[12px]",
        fontSize === "small" && "text-[11px]",
        className,
      )}
    >
      <ul
        className={clsx(
          "ml-[1.5em] flex flex-col",
          lineSpacing === "none" && "space-y-0",
          lineSpacing === "narrow" && "space-y-1",
          lineSpacing === "normal" && "space-y-2",
        )}
      >
        {instructions.map((instruction, index) => (
          <li
            key={index}
            className={clsx(
              "before:ml-[-1.5em] before:pr-[0.5em]",
              classOfMark,
            )}
          >
            {instruction}
          </li>
        ))}
      </ul>
    </div>
  );
}
